/**
 * Class name utility function
 * Combines clsx and tailwind-merge for clean class name composition
 *
 * @example
 * cn('px-4', isActive && 'bg-blue-500', 'text-white')
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[])
{
  return twMerge(clsx(inputs));
}
